import React, { useEffect, useState } from 'react'
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import MobileHeader from '../../components/header/MobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import InstituteHeader from '../../components/header/InstituteHeader';
import CRHeader from '../../components/header/CRHeader';
import NonLoginHeader from '../../components/header/NonLoginHeader';
import Gotop from '../../components/gotop';
import CandidateResume from './CandidateResume';
import { Helmet } from 'react-helmet';

const CandidResume = () => {
    const [isShowMobile, setShowMobile] = useState(false);

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");

    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);
    const module = localStorage.getItem('Module')
  return ( 
    <>
            <Helmet>
				<title> Candidate | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Resume/Candidate | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
      {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader   handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader   handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader   handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader   handleMobile={handleMobile} /> :
                            <NonLoginHeader   handleMobile={handleMobile} />}

                            <div className="container pt-70">
                               <CandidateResume />
                                <Gotop />
                            </div> 
    </>
  )
}

export default CandidResume